import * as React from "react";

import "./section-header.scss";

export default ({ children }: { children: React.ReactNode }) => (
    <div className="section-header">{children}</div>
);
